module.exports = __webpack_public_path__ + "static/media/iotnet6.98eaa835.jpeg";